import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';

import { MoneyPipe } from '@shared/pipes/money.pipe';

import { PaymentScheduleQuery } from '../../state/payment-schedule.query';
import { PaymentQuarterData } from '../../state/payment-schedule.store';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MoneyPipe, AsyncPipe],
  selector: 'aux-payments-history',
  styles: [],
  templateUrl: './payments-history.component.html',
})
export class PaymentsHistoryComponent {
  private paymentScheduleQuery = inject(PaymentScheduleQuery);

  @Input() historyKey!: keyof PaymentQuarterData;
  paymentData$ = this.paymentScheduleQuery.getPaymentScheduleCumulative();
  @Input() title = '';
}
